import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { showModal } from "@/store/slices/modalSlice";
import { resetError } from "@/features/auth/duck/auth";
import SignUpModal from "@/features/auth/signup/SignUp";
import HeartFilledIcon from "@/assets/svg/fav/HeartFilledIcon";
import HeartOutlineIcon from "@/assets/svg/fav/HeartOutlineIcon";

import {
  markPropertyAsFavoriteRequest,
  unMarkPropertyAsFavoriteRequest
} from "@/features/property/duck/property";
import { unMarkProfileAsFavoriteRequest } from "@/features/user/duck/user";
import { useLanguage } from "@/hook/useLanguage";

function MarkPropertyFavorites({
  isFavourite = false,
  propertyId = null,
  userId = null,
  isPIP = false,
  userProfileId = null,
  isProfileCard = false,
  fillColor = "#7B9E7E",
  text
}) {
  const dispatch = useDispatch();
  const { userInfo, loadingFav } = useSelector(
    (state) => ({
      userInfo: state.user.userInfo,
      loadingFav: state.property.loadingFav
    }),
    shallowEqual
  );

  const showSignupModal = () => {
    dispatch(resetError());
    dispatch(
      showModal({
        content: <SignUpModal />,
        classes: "sign-up-modal-container"
      })
    );
  };

  const handleMarkFavorites = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!userInfo) {
      showSignupModal();
      return;
    }
    if (isProfileCard && userProfileId) {
      dispatch(
        unMarkProfileAsFavoriteRequest({ userProfileId, isProfileCard })
      );
    }

    if (!propertyId || loadingFav) {
      return; // Don't perform the action if loading or propertyId is not valid
    }

    // Handle mark/unmark logic
    const action = isFavourite
      ? unMarkPropertyAsFavoriteRequest
      : markPropertyAsFavoriteRequest;
    dispatch(action({ propertyId }));
  };

  const { isRTL } = useLanguage();

  // Styles
  const detailStyle = `border-transparent text-sm !w-auto !h-auto`;
  const favPosition = isRTL ? "left-4" : "right-4";
  const profilePosition = isRTL ? "left-2" : "right-2";

  const favStyle = isPIP
    ? `flex items-center justify-center w-11 h-11 float-${
        isRTL ? "left" : "right"
      } rounded-full border-[1.5px] border-[#CDE9D0] border-solid cursor-pointer  ${detailStyle}`
    : `absolute flex items-center border-[1.5px] border-[#CDE9D0] justify-center bg-white w-11 h-11 ${favPosition} transform -translate-y-1/2 cursor-pointer rounded-full`;
  const profileCardStyle = `absolute border-[1.5px] border-[#CDE9D0] flex items-center justify-center bg-white w-11 h-11 top-0 ${profilePosition} cursor-pointer rounded-full`;

  // If user is viewing their own property, don't render the button
  if (userId === userInfo?.uuid) {
    return null;
  }

  return (
    <>
      <div
        aria-disabled={loadingFav}
        onClick={handleMarkFavorites}
        className={isProfileCard ? `${profileCardStyle}` : `${favStyle}`}>
        {isFavourite ? (
          <HeartFilledIcon width={16} height={16} fill="#DF1C41" />
        ) : (
          <HeartOutlineIcon width={16} height={16} fill={fillColor} />
        )}
        {text && <span className="text-xs ml-1.5">{text}</span>}
      </div>
    </>
  );
}

export default MarkPropertyFavorites;
